// Gatsby requirements
import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import RichTextRenderer from 'utils/richTextRenderer'

// Styles
import * as CSS from './sectionShareButtons.module.scss'

const SectionShareButtons = ({ blok, currentPage }) => {

    return (
        <section
            className={CSS.section}
            id={blok.anchorId}
            style={{ backgroundColor: blok?.backgroundColor }}
            {...storyblokEditable(blok)}
        >

            <div className={`wrapper`}>

                {blok?.richtext &&
                    <div className={CSS.text}>
                        <RichTextRenderer data={blok.richtext} />
                    </div>
                }

                <div className={CSS.share}>
                    <a href={`https://www.facebook.com/sharer/sharer.php?u=https://www.wa.nl/${currentPage}`}><img src="/icons/facebook-share.svg" alt="Share on Facebook"/></a>
                    <a href={`https://twitter.com/intent/tweet?text=https://www.wa.nl/${currentPage}`}><img src="/icons/twitter-share.svg" alt="Share on Twitter"/></a>
                    <a href={`https://www.linkedin.com/shareArticle?mini=true&url=https://www.wa.nl/${currentPage}&summary=&source=`}><img src="/icons/linkedin-share.svg" alt="Share on Linkedin"/></a>
                    <a href={`https://t.me/share/url?url=https://www.wa.nl/${currentPage}`} className={CSS.email}><img src="/icons/telegram-share.svg" alt="Share via Telegram"/></a>
                    <a href={`https://api.whatsapp.com/send?text=https://www.wa.nl/${currentPage}`}><img src="/icons/whatsapp-share.svg" alt="Share on Whatsapp"/></a>
                </div>

            </div>

        </section>
    )
}

export default SectionShareButtons